<div class="subpage-header-cta">
    <app-subpage-header
        [title]="(selectedProduct$ | async).displayName + ' ' + title"
        [favoriteId]="favoriteId"
        size="small"></app-subpage-header>
    <a
        *appProducts="[productEnum.GENESYS_CLOUD_CX]"
        class="no-underline"
        [href]="sectionHyperlinkRoute"
        target="_blank"
        [matTooltip]="sectionHyperlinkLabel"
        [matTooltipShowDelay]="1000"
        [matTooltipHideDelay]="2000">
        {{ sectionHyperlinkLabel }}
        <mat-icon [svgIcon]="'chevron_right'" aria-hidden></mat-icon>
    </a>
</div>

<ul>
    <li>
        <app-home-fundamentals-roadmaps class="column" flexDirection="column"></app-home-fundamentals-roadmaps>
    </li>
    <li *appProducts="[productEnum.GENESYS_CLOUD_CX]">
        <app-home-fundamentals-status></app-home-fundamentals-status>
    </li>
    <li>
        <app-home-fundamentals-release-notes></app-home-fundamentals-release-notes>
    </li>
    <li>
        <app-home-fundamentals-product-ideas-lab></app-home-fundamentals-product-ideas-lab>
    </li>
</ul>
